var map = {
	"./2fa.svg": [
		29234,
		234
	],
	"./alignedLogo.svg": [
		10889,
		889
	],
	"./b.svg": [
		91107,
		107
	],
	"./bootstrap.svg": [
		16803,
		803
	],
	"./copy.svg": [
		77249,
		249
	],
	"./cross.svg": [
		7996,
		996
	],
	"./darkCross.svg": [
		66449,
		449
	],
	"./facebook.svg": [
		85772,
		772
	],
	"./instagram.svg": [
		47733,
		733
	],
	"./linkedin.svg": [
		9067,
		67
	],
	"./message.svg": [
		22817,
		817
	],
	"./npm.svg": [
		57727,
		727
	],
	"./pURL.svg": [
		41828,
		828
	],
	"./pURLCrop.svg": [
		73411,
		411
	],
	"./pURLT.svg": [
		83971,
		971
	],
	"./pURL_Coloured_Logo_Landscape-removebg-preview (1) 2.svg": [
		33470,
		470
	],
	"./purl logo.svg": [
		59412,
		412
	],
	"./react.svg": [
		84782,
		782
	],
	"./redux.svg": [
		96350,
		350
	],
	"./sass.svg": [
		83702,
		702
	],
	"./shareLink.svg": [
		5192,
		192
	],
	"./spacedLogo.svg": [
		69316,
		316
	],
	"./testing.ico": [
		6740,
		740
	],
	"./twitterX.svg": [
		59005,
		5
	],
	"./webpack.svg": [
		73979,
		979
	],
	"./whatsapp.svg": [
		29188,
		188
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 17143;
module.exports = webpackAsyncContext;